import { apiFetch } from '@/lib/api/client';
import type { MessageView, SendMessageInput } from '@/features/messaging/types';
import type { PagedData } from '@/lib/api/types';

/** `GET /students/:studentId/messages`. Tenant-scoped; requires `messages:read`. */
export async function listMessages(
  studentId: string,
  page = 1,
  limit = 50,
): Promise<PagedData<MessageView>> {
  const query = new URLSearchParams({ page: String(page), limit: String(limit) });
  return apiFetch<PagedData<MessageView>>(`/students/${studentId}/messages?${query.toString()}`, {
    tenantScoped: true,
  });
}

/**
 * `POST /students/:studentId/messages`. Tenant-scoped; requires
 * `messages:manage` (Teacher for a student they hold an active class
 * assignment to, or the Student themselves - never Organization Admin).
 */
export async function sendMessage(
  studentId: string,
  input: SendMessageInput,
): Promise<MessageView> {
  return apiFetch<MessageView>(`/students/${studentId}/messages`, {
    method: 'POST',
    body: input,
    tenantScoped: true,
  });
}
